module.exports = __webpack_public_path__ + "static/img/mammadzada.8905f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/mammadzada.jpg
// module id = 477
// module chunks = 10